import script from "./WebinarStreamStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarStreamStudio.vue?vue&type=script&setup=true&lang=js"

import "./WebinarStreamStudio.vue?vue&type=style&index=0&id=a773eb86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a773eb86"]])

export default __exports__